<template>
  <v-app :class="{'background-app': !withoutBg.includes($route.name)}">
    <v-main>
      <v-container>
        <router-view :key="$route.fullPath"></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  data: () => ({
    withoutBg: [
      'HostedCustomerBase',
      'HostedCustomerBaseAuth',
      'HostedSignupForm'
    ]
  })
}
</script>